import React, { useState } from 'react';
import './CalculatorPage.css';

function StartupNameGeneratorWithScore() {
  const [keyword, setKeyword] = useState('');
  const [generatedNames, setGeneratedNames] = useState([]);
  const [error, setError] = useState('');

  const generateNamesAndScore = (inputKeyword) => {
    // Placeholder for Startup Name Generation and Scoring logic
    // This is a highly simplified example. Real generation would be complex.
    if (!inputKeyword) return [];

    const names = [
      `${inputKeyword}Tech`,
      `The${inputKeyword}Hub`,
      `${inputKeyword}Solutions`,
      `Innovate${inputKeyword}`,
      `Pro${inputKeyword}`,
    ];

    const scoredNames = names.map(name => ({
      name: name,
      score: calculateNameScore(name) // Simple score based on length
    }));

    return scoredNames;
  };

  const calculateNameScore = (name) => {
    // Simple scoring logic: longer names get higher scores (placeholder)
    let score = name.length * 10;
    // Add more complex numerology-based scoring here if desired
    return score;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setGeneratedNames([]);

    if (!keyword) {
      setError('Please enter a keyword.');
      return;
    }

    const generated = generateNamesAndScore(keyword);
    if (generated.length === 0) {
      setError('Could not generate names. Please try a different keyword.');
    } else {
      setGeneratedNames(generated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Startup Name Generator with Score",
    "description": "Generate startup name ideas with numerological scores for success.",
    "url": "https://www.yourwebsite.com/startup-name-generator-with-score",
    "potentialAction": {
      "@type": "GenerateAction",
      "name": "Generate Startup Names",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/startup-name-generator-with-score?keyword={keyword}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=keyword"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Startup Name Generator with Score</h1>
      <p className="text-center">Enter a keyword to generate startup name ideas with numerological scores.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="keyword">Enter Keyword:</label>
          <input
            type="text"
            id="keyword"
            className="form-control"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="e.g., Health, Finance, Tech"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Generate Names</button>
      </form>

      {generatedNames.length > 0 && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Generated Names:</h2>
          <ul className="name-list">
            {generatedNames.map((item, index) => (
              <li key={index}>{item.name} (Score: {item.score})</li>
            ))}
          </ul>
          <p className="result-explanation">Scores are based on a simplified numerological calculation. For detailed analysis, consult a numerologist.</p>
        </div>
      )}
    </div>
  );
}

export default StartupNameGeneratorWithScore;
